module.exports = __webpack_public_path__ + "7cacb238db1eaffe307dfc71834c1d6a.svg";